import React from 'react'
import { Tag } from 'antd'
import { PiDotBold } from 'react-icons/pi'
import IntlMessages from '../../util/IntlMessages'

const CoreCompleteTag = () => {
  return (
    <Tag color="#7f00ff" style={{ marginLeft: 10 }}>
      <IntlMessages id="components.freemiumPricingTooltip.coreAndComplete" values={{ icon: () => <PiDotBold style={{ position: 'relative', top: 2 }} /> }} />
    </Tag>
  )
}

export default CoreCompleteTag
